import { render, staticRenderFns } from "./AddToQuoteFooter.vue?vue&type=template&id=21249372&scoped=true&"
import script from "./AddToQuoteFooter.vue?vue&type=script&lang=ts&"
export * from "./AddToQuoteFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AddToQuoteFooter.vue?vue&type=style&index=0&id=21249372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21249372",
  null
  
)

export default component.exports